import { render, staticRenderFns } from "./NavigationBarMenu.vue?vue&type=template&id=7b054cd4&scoped=true&"
import script from "./NavigationBarMenu.vue?vue&type=script&lang=ts&"
export * from "./NavigationBarMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationBarMenu.vue?vue&type=style&index=0&id=7b054cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b054cd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VTab,VTabs,VThemeProvider})
